
import { defineComponent } from "vue";

export default defineComponent({
  name: "CustomRadioButton",
  props: ["modelValue", "name", "value"],
  emits: ["update:modelValue"],
});
